export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["报价"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我的交易"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我的广告"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易"])}
}